// Module-level store for diff mode + changeSet.
// DiffBoard (app-shell) writes here when studioMode=true.
// StudioCompositionInner reads mode → renders mode tabs in TopBar header.
// StudioCompositionInner reads changeSet → injects into WorkspaceNav diff source.

import { useSyncExternalStore } from "react";
import type { ChangeSet } from "@archlang/engine";

export type DiffMode = "split" | "overlay" | "processes" | "documents";

let _mode: DiffMode = "split";
let _changeSet: ChangeSet | null = null;
const _subs = new Set<() => void>();

function notify() {
  _subs.forEach((fn) => fn());
}

export function setDiffMode(m: DiffMode): void {
  if (_mode === m) return;
  _mode = m;
  notify();
}

export function setDiffChangeSet(cs: ChangeSet | null): void {
  if (_changeSet === cs) return;
  _changeSet = cs;
  notify();
}

export function clearDiffState(): void {
  const needsNotify = _mode !== "split" || _changeSet !== null;
  _mode = "split";
  _changeSet = null;
  if (needsNotify) notify();
}

export function useDiffMode(): DiffMode {
  return useSyncExternalStore(
    (fn) => { _subs.add(fn); return () => _subs.delete(fn); },
    () => _mode,
  );
}

export function useDiffChangeSet(): ChangeSet | null {
  return useSyncExternalStore(
    (fn) => { _subs.add(fn); return () => _subs.delete(fn); },
    () => _changeSet,
  );
}
